export const parseQuery = query => {
  if (query.startsWith('?')) {
    const tuples = query.slice(1).split('&');
    return tuples.reduce((result, tuple) => {
      const [key, value = true] = tuple.split('=');
      if (key) {
        /* eslint-disable no-param-reassign */
        result[key] = decodeURIComponent(value);
      }
      return result;
    }, {});
  }
  return {};
};
